import React from 'react'
import { Route, Switch, NavLink } from 'react-router-dom'

import { APP_URL } from 'config/app'
import { Container, PageContainer } from 'layout'
import {
    NavBar,
    Logo,
    MenuNavMainPublic,
    Footer,
} from 'components'
import { Support, Ticket } from 'containers'
import style from './SupportPage.module.css'

/**
 * Unauthorized support ticket page
 */
const SupportPage: React.FC = () => {
    return (
        <>
            <header>
                <NavBar>
                    <NavLink to="/">
                        <Logo />
                    </NavLink>
                    <MenuNavMainPublic />
                </NavBar>
            </header>

            <Container>
                <PageContainer classes={style.pageContainer}>
                    <Switch>
                        <Route path={APP_URL.support} component={Support} exact />
                        <Route path={APP_URL.ticket} component={Ticket} />
                    </Switch>
                </PageContainer>
            </Container>

            <Footer />
        </>
    )
}

export default SupportPage
